import React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { useFeatureFlagStore } from 'apps/feature-flags/src/store';
import { ListPageTrackingEvent, trackFeatureFlagListPageAction } from 'apps/feature-flags/src/tracking';
import { FeatureFlagPageProvider } from '../context';
import { useQueryFeatureFlagList } from '../hooks/queryFeatureFlagList';
import { FeatureFlagListHeader } from './header';
import { FeatureFlagListMain } from './main';
import styles from './index.module.styl';
interface FeatureFlagListViewProps {
  projectId: number;
  userId: number;
  workspaceId: number;
}
export const FeatureFlagListView: React.FC<FeatureFlagListViewProps> = _ref => {
  let {
    projectId,
    userId,
    workspaceId
  } = _ref;
  const setCurrentFeatureFlag = useFeatureFlagStore(state => state.setCurrentFeatureFlag);
  const featureFlags = useFeatureFlagStore(state => state.featureFlags);
  useQueryFeatureFlagList(projectId);
  React.useEffect(() => {
    // clear previous feature flag so it doesn't show for a second when you click into another one
    setCurrentFeatureFlag(undefined);
    trackFeatureFlagListPageAction({
      event: ListPageTrackingEvent.PageLoaded
    });
  }, []);
  if (featureFlags === undefined) {
    return <SpinnerReact size={SpinnerSize.Large} />;
  }
  return <FeatureFlagPageProvider projectId={projectId} workspaceId={workspaceId} userId={userId} data-sentry-element="FeatureFlagPageProvider" data-sentry-component="FeatureFlagListView" data-sentry-source-file="index.tsx">
      <div className={styles.wrapper}>
        <FeatureFlagListHeader data-sentry-element="FeatureFlagListHeader" data-sentry-source-file="index.tsx" />
        <FeatureFlagListMain data-sentry-element="FeatureFlagListMain" data-sentry-source-file="index.tsx" />
      </div>
    </FeatureFlagPageProvider>;
};